export default __webpack_public_path__ + "static/media/blue-box.75aeacbf.svg";